export const loadContentStyles = () => import("./content.css");
export const loadThemeStyles = () => import("./theme.css");
